import * as React from "react";
import { Loading } from "..";
export const Suspense = ({ children }) => {
    return (React.createElement(React.Suspense, { fallback: React.createElement(Loading, { message: "" }), children: children }));
};
//# sourceMappingURL=Suspense.js.map